import { stakeholderService } from '../services'

export default (countryCode, rut) => {
	return new Promise(resolve => {
		stakeholderService.forgotPassword(countryCode, rut)
			.then(response => {
				if(response) resolve({ success: true, data: response.data })
			})
			.catch(error => {
				if(error && error.response) resolve({ success: false, data: error.response.data })
			})
	})
}
